import { render, staticRenderFns } from "./IncrementsModal.vue?vue&type=template&id=635a4632&scoped=true"
import script from "./IncrementsModal.vue?vue&type=script&lang=js"
export * from "./IncrementsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a4632",
  null
  
)

export default component.exports